<template>
  <div class="client-details-form" v-bind:class="formClass">
    <template v-for="(field, key) in formData.clientDetails.questions">
      <div class="details-form-row">
        <template v-if="field.type === 'text'">
          <label>{{ field.title }}</label>
          <input v-model="field.value" type="text">
        </template>
        <template v-if="field.type === 'phone-number'">
          <label>{{ field.title }}</label>
          <input v-model="field.value" @input="field.value = field.value.replaceAll(/[^+\d]/g, '')" type="text">
        </template>
        <template v-if="field.type === 'datepicker'">
          <label>{{ field.title }}</label>
          <datepicker initial-view="year" v-model="field.value" :disabledDates="field.disabledDates"></datepicker>
        </template>
        <template v-if="field.type === 'email'">
          <label>{{ field.title }}</label>
          <input type="email" v-model="field.value">
        </template>
        <template v-if="field.type === 'textarea'">
          <label>{{ field.title }}</label>
          <textarea v-model="field.value"></textarea>
        </template>
        <template v-if="field.type === 'checkbox'">
          <label class="checkbox-label checkbox-label">
            <input type="checkbox" v-model="field.value"> <span v-html="field.title"></span>
          </label>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapWritableState} from "pinia";
import {FormDataStore} from "../stores/FormDataStore";

export default {
  name: 'Form',
  components: {
    Datepicker
  },
  computed: {
    ...mapWritableState(FormDataStore, ['formData']),
  },
  data: function () {
    return {
      formPlaceholder: 'Date of birth',
      formClass: 'personal',
    }
  },
}
</script>

<style>
label {
  font-weight: 600;
  color: #2484C6;
}
</style>